import React from 'react';
import { Col, Form } from 'react-bootstrap';

// Select Sede Universitaria
const UbicacionSelect = ({ c, i, handleInputChange, valuesRequired }) => {
  return (
    <Col lg={6} xs={12} className="mb-3" key={'form-bodyform-' + i}>
      <Form.Group controlId={'validationCustom' + i}>
        <Form.Label>{c.name + ' *'}</Form.Label>
        <Form.Control
          name="ubicacion"
          as="select"
          onChange={handleInputChange}
          defaultValue={'-1'}
          className="select-contact-form"
          isValid={c.required && valuesRequired.content[c.name] !== undefined}
        >
          <option value="-1" disabled>
            {c.placeholder}
          </option>
          <option value="Córdoba">Córdoba</option>
          <option value="UCC Rio Cuarto">UCC Rio Cuarto</option>
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Seleccione {c.name} por favor
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );
};

export default UbicacionSelect;
